<template>
  <div
    class="credit-card-wrap background-white rounded-regular shadow-light"
    :class="classes"
  >
    <div class="heading d-flex justify-content-between">
      <div class="col-3 pl-0">
        <img :src="`/images/cards/${card.brand}.png`" :alt="card.brand" />
      </div>
      <div class="col-9 text-left pr-0">
        <span class="d-block font-weight-bold font-size-regular text-capitalize">{{ card.brand }}</span>
        <div>
          <ul class="font-size-xSmall text-color2 d-flex">
            <li class="mr-2">
              •••• •••• •••• {{ card.last_digits }}
            </li>
            <li>
              Validade {{ card.expiration_date | VMask('##/##') }}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="d-flex flex-column flex-lg-row justify-content-center justify-content-lg-between mt-3 mt-lg-5">
      <div
        class="font-size-xSmall text-center text-lg-left"
        v-if="card.address"
      >
        <span class="d-block d-lg-flex"><strong>Endereço de cobrança</strong></span>
        <span class="d-block d-lg-flex">{{ `${card.address.street}, ${card.address.number}` }}</span>
        <span class="d-block d-lg-flex">{{ card.address.city }} • {{ card.address.zipcode | VMask('#####-###') }}</span>
      </div>
      <div
        class="d-flex justify-content-center justify-content-lg-end align-items-center mt-3 mt-lg-0"
        v-if="editable"
      >
        <Button
          class="btn-color3 btn-sm"
          v-if="card.is_primary"
        >
          Principal
        </Button>
        <template
          v-else
        >
          <Button
            class="btn-outline-color2 btn-sm"
            @click="openTurnPrimaryModal"
          >
            Tornar principal
          </Button>
          <TurnCreditCardPrimaryModal
            :card="card"
            @credit-card-turned-primary="parseCreditCardTurnedPrimary"
          />
        </template>
        <Button
          class="btn-circle btn-outline-color2 d-inline-block ml-2"
          @click="openDestroyModal"
        >
          <i class="fa fa-trash"></i>
        </Button>
        <DestroyCreditCardModal
          @credit-card-deleted="parseDeletedCreditCard"
          :card="card"
        />
      </div>
    </div>
  </div>
</template>

<script>

import Button from '@/components/common/Button/Button'
import DestroyCreditCardModal from '@/components/credit-cards/DestroyCreditCardModal'
import TurnCreditCardPrimaryModal from '@/components/credit-cards/TurnCreditCardPrimaryModal'
import { mask } from 'vue-the-mask'

export default {
  name: 'CreditCardCard',
  props: ['card', 'size', 'editable'],
  directives: { mask },
  components: {
    Button,
    DestroyCreditCardModal,
    TurnCreditCardPrimaryModal
  },
  computed: {
    cardSize () {
      return this.size ? this.size : 'regular'
    },
    classes () {
      const data = []
      if (this.cardSize === 'regular') {
        data.push('p-4')
      } else if (this.cardSize === 'small') {
        data.push('p-4')
      }

      return data
    }
  },
  methods: {
    openDestroyModal () {
      // v-b-modal.destroy-credit-card
      this.$bvModal.show(`destroy-credit-card-${this.card.id}`)
    },
    openTurnPrimaryModal () {
      // v-b-modal.turn-credit-card-primary
      this.$bvModal.show(`turn-credit-card-primary-${this.card.id}`)
    },
    parseCreditCardTurnedPrimary () {
      this.$emit('credit-card-turned-primary')
    },
    parseDeletedCreditCard () {
      this.$emit('credit-card-deleted')
    }
  }
}
</script>

<style lang="scss" scoped>
.credit-card-wrap {
  color: $color1;
}
</style>
